import { signIn, logOut, getUserData } from '../../features/serverApi/asApi.ts';
import { devlog } from '../../util/utils.ts';
import styleText from './login.css?raw';

export class AsLogin extends HTMLElement {
  static readonly tag = 'as-login' as const;

  private static readonly _sheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText);
    return sheet;
  })();

  private _lastError = '';
  private _userData: any;

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot!.adoptedStyleSheets = [
      ...this.shadowRoot!.adoptedStyleSheets,
      AsLogin._sheet
    ];
    this._render();
  }

  private _render() {
    this.shadowRoot!.innerHTML = /*html*/`
      <div class="as-login">
        <form id="loginForm">
          email: <input name="eMail" id="email" autocomplete="email" type="email"><br>
          password: <input name="password" id="password" type="password" autocomplete="current-password"><br>
          <button type="button" id="loginButton">login</button>
        </form>
        
        <button type="button" id="logoutButton">logout</button><br>
        ${this._lastError ? `<span id="loginError">${this._lastError}</span>` : ''}
        
        user's first name: <span id="userFirstName">${this._userData?.firstName ?? ''}</span>
      </div>
    `;
  }

  connectedCallback() {
    this._addEventListeners();
    getUserData()
      .then(response => {
        this._userData = response.userData;
        devlog(this._userData);
        this._render();
        this._addEventListeners();
      })
      .catch(error => console.error(error));
  }

  disconnectedCallback() {
    this._removeEventListeners();
  }

  private _handleLogin = () => {
    const loginForm = this.shadowRoot?.querySelector('#loginForm') as HTMLFormElement | null;
    if (!loginForm) {
      console.error('loginForm is null');
      return;
    }

    signIn(new FormData(loginForm))
      .then(res => {
        this._lastError = res.success === false ? (res.message ?? 'Login failed') : '';
        this._userData = res.userData;
        this._render();
        this._addEventListeners();
      })
      .catch(error => console.error(error));
  };

  private _handleLogout = () => {
    logOut({ reload: false })
      .then(ok => {
        devlog('signed out', ok);
        this._userData = undefined;
        this._render();
        this._addEventListeners();
      })
      .catch(error => console.error(error));
  };

  private _addEventListeners() {
    const loginButton = this.shadowRoot?.querySelector('#loginButton');
    const logoutButton = this.shadowRoot?.querySelector('#logoutButton');

    loginButton?.addEventListener('click', this._handleLogin);
    logoutButton?.addEventListener('click', this._handleLogout);
  }

  private _removeEventListeners() {
    const loginButton = this.shadowRoot?.querySelector('#loginButton');
    const logoutButton = this.shadowRoot?.querySelector('#logoutButton');

    loginButton?.removeEventListener('click', this._handleLogin);
    logoutButton?.removeEventListener('click', this._handleLogout);
  }
}

customElements.define(AsLogin.tag, AsLogin);
